import { webClient, webClientConfig } from "@shared/apis"
import { Role } from "@shared/contexts"
import {
  auth,
  getCookies,
  kick,
  removeTokens,
  setTokens,
} from "@shared/modules"

import Cookies from "js-cookie"

export default {
  me: () => {
    return webClient.get<User>("/account/me")
  },
  check: async (
    scheduleId: number | string,
    ticket: string,
    username: string,
    partnerId?: number | string | undefined,
    isVodPlayer?: boolean | undefined,
  ) => {
    try {
      const { data: account } = await webClient.post("/account/check", {
        scheduleId,
        ticket,
        username,
        partnerId,
        isVodPlayer,
      })

      webClient.defaults.headers["Authorization"] = account.tokens.accessToken
      setTokens({ ...account.tokens, scheduleId })
    } catch (err) {
      throw err
    }
  },
  checkOtp: async (scheduleId: number | string, otp: string) => {
    try {
      const { data: tokens } = await webClient.get("/account/otp", {
        params: { scheduleId, otp },
      })

      webClient.defaults.headers["Authorization"] = tokens.accessToken
      setTokens({ ...tokens, scheduleId })
    } catch (err) {
      throw err
    }
  },
  loginAnonymous: () => auth().signInAnonymously(),
  login: (chattingToken: string): Promise<firebase.auth.UserCredential> =>
    auth().signInWithCustomToken(chattingToken),
  token: {
    refresh: async (): Promise<Token | undefined> => {
      try {
        const scheduleId = webClientConfig.scheduleId

        const { data: token } = await webClient.post<Token>(
          "/account/token/refresh",
          {
            scheduleId,
            refreshToken: getCookies("refreshToken"),
          },
        )
        webClient.defaults.headers["Authorization"] = token.accessToken

        setTokens({ ...token, scheduleId })

        return token as Token
      } catch {
        removeTokens()
        kick("사용자 정보가 만료 되었습니다.")
        return
      }
    },
  },
}

export interface Token {
  accessToken: string
  refreshToken: string
  chattingToken: string
  wmsAuthToken: string
  vodWmsAuthToken: string
  createdAt: string
}

export interface User {
  id: number
  username: string
  nickname: string
  role: Role
  profileImageUrl: string
  kakaoPlusFriendUrl: string
  youtubeSubscribeUrl: string
  isAllowedBlockChat: boolean
  isAllowedKick: boolean
  partner?: Partner
}

export interface Partner {
  displayName: string
  id: number
  isUseNimble: boolean
  isUsePreview: boolean
  uniqueId: string
  vodApplication: string
  createdAt: string
  updatedAt: string
  previewTime: number
  /** 미리보기 종료 팝업 문구 */
  popupMessage: string | null
  /** 미리보기 종료 팝업 내 버튼 문구 */
  popupButtonText: string | null
}
